<div class="add-to-cart-wrapper-cx">
  @if (productCode && showQuantity) {
  <div class="quantity">
    @if (hasStock) {
    <cx-item-counter
      [allowZero]="true"
      [min]="min"
      [max]="max"
      [control]="addToCartForm.get('quantity')"
      (update)="updateCount($event)"
      (keypress)="numberOnly($event)"
      [moq]="minOrderQuantity"
      (hasMinQtyError)="setProductPricingFloatHeight()"
      [readonly]="isDisabled || isLoadDisabled || !hasStock || !hasPDPDealerPrice || isDiscontinued"
    ></cx-item-counter>
    }
  </div>
  }
  <div class="add-to-cart-containter">
    <div
      matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      [matTooltipClass]="'button-tooltip'"
      aria-label="displays a tooltip in bottom"
      [matTooltipDisabled]="deviceDetectorService.isMobile() || deviceDetectorService.isTablet()"
    >
      <button
        class="btn btn-primary btn-block btn-add-to-cart"
        type="button"
        [disabled]="
          isDisabled ||
          isLoadDisabled ||
          hasInvalidQuantity ||
          !hasStock ||
          isDiscontinued ||
          ((isProductDetailsPage$ | async) && !hasPDPDealerPrice)
        "
        (click)="backorderCartCheck(orderFormDetails)"
        [ngClass]="{
          rotating: addToCartInprogress
        }"
      >
        @if (!addToCartInprogress) {
        <mat-icon svgIcon="add-to-cart"></mat-icon>
        } @else { }
      </button>
    </div>
    @if (showOrderFormLink && baseProduct$ | async; as baseProduct) {
    <button class="btn btn-link order-form" disableRipple [ngClass]="activeLanguage$ | async">
      <span class="mat-button-wrapper">
        <mat-icon class="material-icons-sharp">shopping_cart</mat-icon>
        <a
          class="align-middle order-form-link"
          [routerLink]="
            { cxRoute: 'orderForm', params: { code: baseProduct?.code, name: escape(baseProduct?.nameHtml) } } | cxUrl
          "
          >{{ 'orderForm.label' | cxTranslate }}</a
        >
      </span>
    </button>
    }
  </div>
</div>
